// extracted by mini-css-extract-plugin
export default {"container":"LoginLanguageSelect--container--a51bba"};